import { render, staticRenderFns } from "./UtilIframe.vue?vue&type=template&id=554ec0ac&scoped=true"
import script from "./UtilIframe.vue?vue&type=script&lang=js"
export * from "./UtilIframe.vue?vue&type=script&lang=js"
import style0 from "./UtilIframe.vue?vue&type=style&index=0&id=554ec0ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554ec0ac",
  null
  
)

export default component.exports